import { useState, useEffect } from 'react';

const useDataLoader = (data, loadingCondition = null) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Si une condition de chargement spécifique est fournie, l'utiliser
    if (loadingCondition !== null) {
      setLoading(loadingCondition);
    } 
    // Sinon, vérifier si les données existent
    else if (data !== undefined && data !== null) {
      // Pour les objets ou tableaux, on vérifie s'ils ont du contenu
      if (typeof data === 'object') {
        if (Array.isArray(data)) {
          setLoading(data.length === 0);
        } else {
          setLoading(Object.keys(data).length === 0);
        }
      } else {
        // Pour les autres types de données
        setLoading(!data);
      }
    } else {
      setLoading(true);
    }
  }, [data, loadingCondition]);

  return loading;
};

export default useDataLoader;